import { SESSION_REPAIR_STATUS_LABELS } from '../../session-repair/constants';
import type { SpectralWorkspaceSession } from '../types';
import type { SessionFullTractMetrics } from '../utils/computeSessionFullTractMetrics';

const formatMetric = (value: number | null | undefined) =>
  value == null || !Number.isFinite(value) ? '' : value;

export const buildSessionsExport = ({
  sessions,
  metrics,
}: {
  analysisName: string;
  sessions: SpectralWorkspaceSession[];
  metrics: SessionFullTractMetrics[];
  exportDateLabel: string;
}) => {
  const metricsBySessionId = new Map(
    metrics.map(metric => [metric.sessionId, metric])
  );

  return sessions.map(session => {
    const tractMetrics = metricsBySessionId.get(session.sessionId);
    const repairStatus = session.repairStatus
      ? SESSION_REPAIR_STATUS_LABELS[session.repairStatus]
      : 'Non analizzata';

    return {
      session_id: session.sessionId,
      utente: session.patientCode ?? '',
      stato_caricamento: session.status,
      stato_qualita: repairStatus,
      eventi_hr: session.events?.length ?? 0,
      hr_medio: formatMetric(tractMetrics?.meanHr),
      rr_medio_ms: formatMetric(tractMetrics?.meanRrMs),
      rmssd_ms: formatMetric(tractMetrics?.rmssdMs),
      lf_hf: formatMetric(tractMetrics?.lfHfRatio),
      duplicati: session.duplicateCount ?? '',
      gap: session.gapCount ?? '',
      dati_riparati: session.hasHrDataRepaired ? 'si' : 'no',
      errore: session.error ?? '',
    };
  });
};
